import React from 'react'
import { Button, Modal } from 'semantic-ui-react'
import { Text } from '../../helpers/language';

const DeleteUserModal = (props) => {
  const {openModal, setOpenModal, handleDelete} = props;

const handleClose = () => {
    handleDelete();
    // getUsers();
    setOpenModal(false)
}
return (
    <>
    <Modal size='mini' open={openModal} onClose={() => setOpenModal(false)}>
        <Modal.Header><Text tid="user_delete_header" /></Modal.Header>
        <Modal.Content>
        <p><Text tid="user_delete_message" /></p>
        </Modal.Content>
        <Modal.Actions>
        <Button negative onClick={() => setOpenModal(false)}><Text tid="no" /></Button>
        <Button
            className='lisia-blue'
            onClick={handleClose}
        >
            <Text tid="yes" />
        </Button>
        </Modal.Actions>
    </Modal>
    </>
)
}

export default DeleteUserModal